import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoTabSectionLR from 'eco-design/sections/eco-tab-section-l-r';
import { getJpIconList } from './config';

const IndustryLeadingA: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesStation.IndustryLeadingA');

    const renderContentTab = (tab: string) => {
        const tabData = getJpIconList(tab);

        return (
            <div className="tab-content-box">
                {tabData.map((item, index) => {
                    const IconComp = item.icon;
                    return (
                        <div className="desc-item" key={index}>
                            <div className="item-icon">
                                <IconComp />
                            </div>
                            <div className="item-name">{item.name}</div>
                            <div className="item-desc">
                                {item.prefix}
                                <span className="item-time">{item.time}</span>
                                <span>{item.unit}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <section className={`${styles.IndustryLeadingA} GtmModuleData-section`} id="IndustryLeadingA" data-section-id={'IndustryLeadingA'}>
            <div className="industry-bg-wrap">
                <div className="title-box">
                    <h4 className="title">{t('title')}</h4>
                    <p className="desc">{t('desc')}</p>
                </div>
                <EcoTabSectionLR
                    items={[
                        {
                            desc: renderContentTab('a'),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1756721453824/industry-img-1-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1756721453824/industry-img-1-pc.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757373474655/industry-img-1-m%20(1).jpg',
                            tabLabel: t('tab_1'),
                            tabValue: 'a',
                            title: '',
                        },
                        {
                            desc: renderContentTab('b'),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1756721453987/industry-img-2-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1756721453987/industry-img-2-pc.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1757373457553/industry-img-2-m%20(1).jpg',
                            tabLabel: t('tab_2'),
                            tabValue: 'b',
                            title: '',
                        },
                        {
                            desc: renderContentTab('c'),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1762224129747/Mask%20group.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1762224129747/Mask%20group.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1762224129673/m-33.jpg',
                            tabLabel: t('tab_3'),
                            tabValue: 'c',
                            title: '',
                        },
                        {
                            desc: renderContentTab('d'),
                            pc: 'https://websiteoss.ecoflow.com/upload/image/1756721454398/industry-img-4-pc.jpg',
                            pad: 'https://websiteoss.ecoflow.com/upload/image/1756721454398/industry-img-4-pc.jpg',
                            h5: 'https://websiteoss.ecoflow.com/upload/image/1762399581715/Mask%20group%20(1).jpg',
                            tabLabel: t('tab_4'),
                            tabValue: 'd',
                            title: '',
                        },
                    ]}
                ></EcoTabSectionLR>
                <div className="industry-tips">
                    <p>{t('tip_1')}</p>
                    <p>{t('tip_2')}</p>
                    <p>{t('tip_3')}</p>
                </div>
            </div>
        </section>
    );
};

export default IndustryLeadingA;
